import { Gallery } from '../api/adserver';

const getTopImageUrl = (gallery: Gallery) => {
  let topImageUrl = null;
  if (gallery.images && gallery.images.length > 0) {
    topImageUrl = gallery.images[0].url;
  }
  return topImageUrl;
};

export { getTopImageUrl };
